import clsx from 'clsx';
import React, { useState, useRef } from 'react';
import { useTranslation } from 'next-i18next';
import useOnClickOutside from '@hooks/browser-events/use-on-click-outside';
import styles from './personalized-sort.module.scss';

type PersonalizedSortProps = {
  disabled: boolean;
  value?: string;
  options: { [key: string]: string };
  onChange?: (key: string) => void;
  pageType?: string;
  isInsideTheFeed?: boolean;
} & React.HTMLProps<HTMLDivElement>;

const PersonalizedSort: React.FC<PersonalizedSortProps> = ({
  value,
  disabled,
  options,
  onChange,
  pageType = 'personalized',
  isInsideTheFeed = false,
}) => {
  const { t } = useTranslation();
  const DropdownRef = useRef(null);
  const [showDropDown, setShowDropDown] = useState<boolean>(false);

  useOnClickOutside(DropdownRef, () => setShowDropDown(false));
  const toggleDropDown = () => {
    setShowDropDown(!showDropDown);
  };

  return (
    <div
      ref={DropdownRef}
      className={clsx(
        styles.sortDropDown,
        { [styles.sortDropDownEmpty]: disabled },
        { [styles['sortDropDown--isInsideTheFeed']]: isInsideTheFeed },
        'vc-d-md-flex-title-m',
      )}
      data-cy={`${pageType}__sortDropDown__empty`}
    >
      <div
        className={clsx(
          styles.sortDropDown__wrapper,
          { [styles.sortDropDownEmpty__wrapper]: disabled },
          { [styles.open]: showDropDown && !disabled },
        )}
      >
        <button
          type="submit"
          className={clsx(styles.sortDropDown__wrapper__btn, {
            [styles.sortDropDownEmpty__wrapper__btn]: disabled,
          })}
          data-cy={`${pageType}__sortDropDown__button`}
          onClick={toggleDropDown}
          aria-expanded={showDropDown}
          aria-controls={`${pageType}-sort-options`}
        >
          <span>{t(disabled ? 'FAVORITE_PAGE.SORT_BY' : options[value] ?? value)}</span>
        </button>
        <div
          className={clsx(styles.sortDropDown__wrapper__text, {
            [styles.open]: showDropDown && !disabled,
          })}
          data-cy={`${pageType}__sortDropDown__text`}
          id={`${pageType}-sort-options`}
        >
          <ul>
            {Object.entries(options).map(([key, label]) => (
              <li
                key={key ?? t(label)}
                className={clsx({
                  [styles.sortDropDown__wrapper__text__self]: key === value,
                  [styles.sortDropDown__wrapper__text_unselected]: key !== value,
                })}
                data-cy={
                  key === value
                    ? `${pageType}__sort__${key ?? t(label)}__selected`
                    : `${pageType}__sort__${key ?? t(label)}__unselected`
                }
              >
                <button
                  onClick={() => {
                    setShowDropDown(false);
                    onChange?.(key);
                  }}
                >
                  {t(label)}
                </button>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default PersonalizedSort;
